import { render } from "./_form-select.vue?vue&type=template&id=10328829"
import script from "./_form-select.vue?vue&type=script&lang=js"
export * from "./_form-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__